import { Injectable, signal, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private platformId = inject(PLATFORM_ID);
  public isOnline = signal(true); // Alapértelmezetten online (SSR környezetben)
  private snackBarRef: any;

  constructor(private snackBar: MatSnackBar) {
    // Csak böngésző környezetben inicializálunk
    if (isPlatformBrowser(this.platformId)) {
      this.isOnline.set(navigator.onLine);
      this.initNetworkListeners();
    }
  }

  private initNetworkListeners(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.addEventListener('online', () => {
      this.isOnline.set(true);
      this.snackBarRef?.dismiss();
      this.snackBar.open(
        'Internetkapcsolat helyreállt',
        'Bezár',
        {
          duration: 3000,
          panelClass: ['success-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'top'
        }
      );
    });

    window.addEventListener('offline', () => {
      this.isOnline.set(false);
      this.snackBarRef = this.snackBar.open(
        'Nincs internetkapcsolat. A funkciók korlátozottak.',
        'Bezár',
        {
          duration: 0,
          panelClass: ['error-snackbar'],
          horizontalPosition: 'center',
          verticalPosition: 'top'
        }
      );
    });
  }
}
